import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-flights-destination-skeleton',
  templateUrl: './flights-destination-skeleton.component.html',
  styleUrls: ['./flights-destination-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightsDestinationSkeletonComponent {}
